import { writable } from "svelte/store";

const { subscribe, set } = writable<string>();
const supportedLocales = JSON.parse(import.meta.env.VITE_SUPPORTED_LOCALES);

/**
 * Initialize the locale if it's valid.
 *
 * @param locale The locale to set.
 */
function init(locale): void {
  if (supportedLocales.includes(locale)) {
    set(locale);
  } else {
    console.error(
      `Trying to set an unsupported locale! Available locales are: ${supportedLocales}. Locale given: ${locale}`
    );
  }
}

export const locale = {
  subscribe,
  init,
};
